import { api } from '@/api/client'

export type FeedbackStatus = 'new' | 'done'

export type AdminFeedback = {
  id: string
  title: string
  body: string
  status: FeedbackStatus
  created_at: string
  resolved_at: string | null
  user_id: string | null
  full_name: string | null
  email: string | null
}

export type FeedbackDraft = {
  title: string
  body: string
}

export async function submitFeedback(draft: FeedbackDraft): Promise<void> {
  await api.POST('/api/v1/feedback', { body: draft })
}

export async function adminListFeedback(): Promise<AdminFeedback[]> {
  const { data } = await api.GET('/api/v1/feedback')
  return data! as AdminFeedback[]
}

export async function setFeedbackStatus(id: string, status: FeedbackStatus): Promise<void> {
  await api.PATCH('/api/v1/feedback/{id}', { params: { path: { id } }, body: { status } })
}

export async function deleteFeedback(id: string): Promise<void> {
  await api.DELETE('/api/v1/feedback/{id}', { params: { path: { id } } })
}

export type UnseenFeedback = {
  unseen_count: number
  latest_created_at: string | null
}

export async function getUnseenFeedback(): Promise<UnseenFeedback> {
  const { data } = await api.GET('/api/v1/feedback/unseen')
  return data!
}

export async function markFeedbackSeen(seenAt?: string): Promise<void> {
  await api.POST('/api/v1/feedback/seen-markers', { body: { seen_at: seenAt ?? null } })
}
